export type EncounterDifficulty = 'heroic' | 'mythic'

export type EncounterAbilityCategory =
  | 'BLEED'
  | 'ENRAGE'
  | 'HEALER'
  | 'INTERRUPT'
  | 'MAGIC'
  | 'TANK'
  | null

export type EncounterAbilityEntry = {
  time: number
  duration: number
}

export type EncounterAbility = {
  spell_id: number
  color: string
  entries: EncounterAbilityEntry[]
  name: string | null
  category: EncounterAbilityCategory
}

export const encounterAbilityAssignmentGroupsBySpellId: Record<number, number> =
  {
    1248983: 4,
  }

export const getEncounterAbilityAssignmentGroups = (spellId: number) =>
  encounterAbilityAssignmentGroupsBySpellId[spellId] ?? 1

export type EncounterPhase = {
  name: string
  abilities: EncounterAbility[]
}

export type EncounterTimelineDifficulty = {
  maxTime: number | null
  difficulty: EncounterDifficulty
  phases: EncounterPhase[]
}

export type EncounterTimelineEncounter = {
  name: string
  difficulties: EncounterTimelineDifficulty[]
  encounter_id: number
  instance_id: number
}

export type EncounterEvents = Record<string, EncounterTimelineEncounter>
